
import { Component, inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants, DocumentExtensionHandling } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-proof-of-payment',
  templateUrl: './proof-of-payment.component.html',
  styleUrls: ['./proof-of-payment.component.scss']
})
export class ProofOfPaymentComponent {
 @Input({required: true}) paymentAmount!: string | undefined;
 @Input() isModal: boolean = false;
 readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {}

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { 
            fileName: DocumentConstants.PROOF_OF_PAYMENT,
            allowedFileTypes: [ ...DocumentExtensionHandling.IMAGE_FILE_EXTENSIONS, ...DocumentExtensionHandling.PDF_FILE_EXTENSIONS ],
            fileAcceptTypes: [ ...DocumentExtensionHandling.IMAGE_ACCEPT_TYPE, ...DocumentExtensionHandling.PDF_ACCEPT_TYPE ],
            paymentAmount: this.paymentAmount
           }
        });
    dialogRef.afterClosed().subscribe();
  }

  get hasProofOfPaymentFile(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.PROOF_OF_PAYMENT);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.PROOF_OF_PAYMENT);
  }

  get showRequiredError(): boolean {
    if(this.isModal) {
      return false;
    }
    
    return !this.formService.isPaymentCompleted() && this.formService.isShowingErrorSections && !this.hasProofOfPaymentFile;
  }

}
